import React from "react";
import UIDs from "../../UIDs";
import { withTranslation } from "react-i18next";

const uid = UIDs.components.ui.ellipsistext;

class EllipsisText extends React.Component {
    state = {
        showAll: false,
        needHidden: false
    };

    handleContent = () => {
        if (this.props.onCollapse) {
            // 由外部控制是否折叠显示
            this.props.onCollapse();
        }
        else {
            let { showAll } = this.state;
            this.setState({
                showAll: !showAll
            });
        }
    };

    onClickContent= () => {
        if (this.props.onClickContent) {
            this.props.onClickContent();
        }
    };

    isElementCollision = (ele) => {
        if (!ele) {
            return false;
        }

        const differ = ele.offsetHeight - 100;
        return differ === -100 ? true : differ > 0;
    };

    componentDidMount = () => {
        let needHidden = this.isElementCollision(this.content);

        if (!this.state.needHidden) {
            this.setState({ needHidden });
        }
    };

    render() {
        let { needHidden, showAll } = this.state;
        if (this.props.onCollapse) {
            // 由外部控制是否折叠显示
            showAll = this.props.showAll;
        }
        return (
            <div style={{ marginTop: this.props.badge ? 15 : 0 }}>
                {!showAll && needHidden ? 
                    <div ref={self => this.content = self} style={{ height: 80, overflow: "hidden", padding: 5, whiteSpace: "pre-line" }} onClick={() => {this.onClickContent();}}>
                        {this.props.content}
                    </div>
                    :
                    <div ref={self => this.content = self} style={{ padding: 5, whiteSpace: "pre-line" }} onClick={() => {this.onClickContent();}}>
                        {this.props.content}
                    </div>
                }
                {needHidden && (
                    <div style={{ marginTop: 10, width: "100%", backgroundColor: "#DCDCDC", textAlign: "center", borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}
                        onClick={() => {
                            this.handleContent();
                        }}>
                        {!showAll ? 
                            <>
                                <i className="ni ni-bold-down" style={{ fontSize: 25 }} />
                                <div>
                                    {this.props.t("showFullText")}
                                </div> 
                            </>
                            :
                            <>
                                <i className="ni ni-bold-up" style={{ fontSize: 25 }} />
                                <div>
                                    {this.props.t("collapse")}
                                </div> 
                            </>
                        }
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation(uid)(EllipsisText);
